import { render, staticRenderFns } from "./Lecture.vue?vue&type=template&id=08909e11"
import script from "./Lecture.vue?vue&type=script&lang=js"
export * from "./Lecture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08909e11')) {
      api.createRecord('08909e11', component.options)
    } else {
      api.reload('08909e11', component.options)
    }
    module.hot.accept("./Lecture.vue?vue&type=template&id=08909e11", function () {
      api.rerender('08909e11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Lecture.vue"
export default component.exports